import { Type } from '@sinclair/typebox';
import { priceMajorMinorInclOnlySchema, priceMajorMinorSchema } from "../price.mjs";
import { cartPaymentSchema } from "./payment.mjs";
import { cartShippingSchema } from "./shipping.mjs";
export const cartCheckoutSchema = Type.Object({
    payment: cartPaymentSchema,
    shipping: cartShippingSchema,
    showVatInput: Type.Boolean(),
    /**
     * If the checkout should show a the contents/lines in the cart. This will be false
     * if the payment provider UI shows the cart contents.
     */
    showCartLinesSection: Type.Boolean(),
    /**
     * If the checkout should show a UI to fill out customer details. If not, customer
     * details will be shown inside the payment providers UI.
     */
    showCustomerSection: Type.Boolean(),
    /**
     * If the checkout should show a UI to select a shipping method. If not, shipping
     * methods will be shown inside the payment providers UI.
     */
    showShippingSection: Type.Boolean(),
    /**
     * If the checkout should show a UI to select a payment method. If not, shipping
     * methods will be shown inside the payment providers UI.
     */
    showPaymentSection: Type.Boolean(),
    /**
     * If the checkout should show a buy button. This will be false if showPaymentSection is false,
     * and if a payment method has it's own buy button such as PayPal.
     */
    showBuyButton: Type.Boolean(),
    /**
     * If the checkout should show an invoice payment option.
     */
    showInvoicePaymentOption: Type.Optional(Type.Boolean()),
    /**
     * The total amount to pay excluding what the customer pays with gift cards. Eg if the cart is worth 100 USD
     * and the customer has a gift card worth 50 USD, the total will still be 100 USD.
     * The leftToPay is the total amount to pay with eg credit card which is the amount excluding
     * what you pay with gift cards.
     */
    total: priceMajorMinorSchema,
    /**
     * This is the total cost of the line items excluding discounts, excluding any fees.
     */
    subTotal: priceMajorMinorSchema,
    /**
     * The total amount left to pay, including VAT. Note that there is no	leftToPayExclTax because
     * the total amount left to pay is always including VAT. In this world nothing can be said
     * to be certain, except death and taxes.
     * This is basically the total minus what the customer pays with gift cards, so it'll be the
     * same as total.amountInclTax if the customer doesn't pay with gift cards.
     */
    leftToPay: priceMajorMinorInclOnlySchema,
});
//# sourceMappingURL=checkout.js.map